import { render, staticRenderFns } from "./mydoctor.vue?vue&type=template&id=464d7196"
import script from "./mydoctor.vue?vue&type=script&lang=js"
export * from "./mydoctor.vue?vue&type=script&lang=js"
import style0 from "./mydoctor.vue?vue&type=style&index=0&id=464d7196&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports